import StagedModal from './StagedModal';

export type { IStagedModalStep } from './StagedModal.types';
export default StagedModal;
